<template>
    <div class="container-fluid py-3 pd-product" style="">
        <!-- HEADER -->
        <div class="d-flex justify-content-between align-items-center mb-3">

            <input v-model="keyword" class="form-control w-50" placeholder="Tìm sản phẩm" />
        </div>

        <!-- PRODUCT GRID -->
        <div class="row g-3">
            <div class="col-xl-2 col-lg-3 col-md-4 col-6" v-for="p in filteredProducts" :key="p.id">
                <div class="product-box" @click="openDetail(p)">
                    <!-- IMAGE -->
                    <div class="img-box">
                        <img :src="getImages(p)[0]" @error="onImgError" />
                        <div v-if="p.sale > 0" class="sale-badge">
                            -{{ p.sale }}%
                        </div>
                    </div>

                    <!-- INFO -->
                    <div class="p-2">
                        <div class="product-name">
                            {{ p.name }}
                        </div>

                        <!-- PRICE -->
                        <div v-if="p.price > 0" class="price-box">
                            <span class="price">
                                {{ formatPrice(finalPrice(p)) }}₫
                            </span>
                            <span v-if="p.sale > 0" class="old-price">
                                {{ formatPrice(p.price) }}₫
                            </span>
                        </div>

                        <div v-else class="contact-price">

                            <span class="price">Liên hệ </span>
                        </div>

                        <!-- SOLD -->
                        <!-- <div class="sold">
                            Đã bán {{ p.sold || 0 }}
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- FLOATING BUTTON -->
    <div class="chat-fab" @click="showChat = true">
        <img src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1767779372560sibSF"
            style="border-radius: 50%;" alt="chatbot" width="28" height="28" />

    </div>

    <!-- CHAT MODAL -->
    <transition name="chat-slide">
        <div v-if="showChat" class="chat-overlay">
            <ProductChatbot :products="products" @close="showChat = false" />
        </div>
    </transition>
    <transition name="sheet-slide">
        <div v-if="showDetail" class="sheet-overlay" @click.self="closeDetail">
            <ProductDetailSheet :product="selectedProduct" @close="closeDetail"   @buy="openCheckout"/>
        </div>
    </transition>
<!-- // đặt hàng -->
    <!-- <transition name="sheet-slide">
  <div v-if="showCheckout" class="sheet-overlay">
    <CheckoutSheet
      :product="checkoutProduct"
      @close="showCheckout = false"
    />
  </div>
</transition> -->
</template>

<script>
import MainProductChatbot from './MainProductChatbot.vue';
import ProductDetailSheet from './MainDetalProduct.vue';
import CheckoutSheet from './MainCheckoutSheet.vue';
export default {
    name: "ProductList",
    components: {
        ProductChatbot: MainProductChatbot,
        ProductDetailSheet,
        // eslint-disable-next-line vue/no-unused-components
        CheckoutSheet
    },
    data() {
        return {
            keyword: "",
            products: require("@/components/json/jsonProduct.json"),
            showChat: false,

            // 👇 detail
            showDetail: false,
            selectedProduct: null,

             showCheckout: false,
    checkoutProduct: null
        };
    },
    computed: {
        filteredProducts() {
            return this.products.filter(p =>
                p.name.toLowerCase().includes(this.keyword.toLowerCase())
            );
        }
    },
    methods: {
        openDetail(p) {
            this.selectedProduct = p;
            this.showDetail = true;
        },
        openCheckout(product) {
    this.checkoutProduct = product;
    this.showCheckout = true;
  },
        closeDetail() {
            this.showDetail = false;
        },
        getImages(p) {
            if (!p.image) return [];
            return p.image.split(";").filter(i => i);
        },
        formatPrice(v) {
            return v.toLocaleString("vi-VN");
        },
        finalPrice(p) {
            return p.sale > 0
                ? p.price - (p.price * p.sale) / 100
                : p.price;
        }
    }
};

//   {
//     "id": 12,
//     "name": "Bộ phát wifi 4G ROOSEE",
//     "price": 0,
//     "sale": 0,
//     "description": "Bộ phát wifi 4G di động mini ROOSEE M610, chuẩn wifi 6, không cần lắp sim, máy nhẹ chỉ 80g, dung lượng pin 2100 mAh, Mifi di động",
//     "image": "https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1767780957942y6xkF"
//   },
</script>

<style scoped>
    .pd-product{
padding-left: 50px; padding-right: 50px;
    }
.sheet-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .4);
    z-index: 9999;
}

/* animation */
.sheet-slide-enter-active,
.sheet-slide-leave-active {
    transition: all .25s ease;
}

.sheet-slide-enter-from,
.sheet-slide-leave-to {
    opacity: 0;
}

.chat-fab {
    position: fixed;
    bottom: 250px;
    right: 24px;
    width: 56px;
    height: 56px;
    background: #ffffff;
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    cursor: pointer;
    box-shadow: 0 8px 20px rgba(0, 0, 0, .3);
    z-index: 999;

    animation: shake 4s infinite;
    transition: transform 0.2s ease;
}

.chat-fab:hover {
    transform: scale(1.1);
}

.chat-overlay {
    position: fixed;
    bottom: 90px;
    right: 24px;
    z-index: 1000;
}

@keyframes shake {
    0% {
        transform: rotate(0);
    }

    2% {
        transform: rotate(5deg);
    }

    4% {
        transform: rotate(-5deg);
    }

    6% {
        transform: rotate(4deg);
    }

    8% {
        transform: rotate(-4deg);
    }

    10% {
        transform: rotate(0);
    }

    100% {
        transform: rotate(0);
    }
}

.chat-slide-enter-active,
.chat-slide-leave-active {
    transition: all 0.3s ease;
}

.chat-slide-enter-from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
}

.chat-slide-enter-to {
    opacity: 1;
    transform: translateY(0) scale(1);
}

.chat-slide-leave-from {
    opacity: 1;
    transform: translateY(0) scale(1);
}

.chat-slide-leave-to {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
}

.chat-fab::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: rgba(11, 3, 255, 0.4);
    animation: pulse 2s infinite;
    z-index: -1;
}
@media (max-width: 768px) {
    .container {
        margin: 0 auto;
        height: auto;
        text-align: center;
        overflow: hidden;
        border-radius: 0px;
    }
     .pd-product{
padding-left: 10px; padding-right: 10px;
    }
}
@keyframes pulse {
    0% {
        transform: scale(1);
        opacity: .6;
    }

    100% {
        transform: scale(1.6);
        opacity: 0;
    }
}

/* PRODUCT BOX */
.product-box {
    background: #fff;
    border: 1px solid #eee;
    transition: 0.2s;
    line-height: 2;
    border-radius: 10px;
    /* height: 100%; */
}

.product-box:hover {
    border-color: #086dac;
    transform: translateY(-2px);
}

/* IMAGE */
.img-box {
    position: relative;
    width: 100%;
    aspect-ratio: 1 / 1;
    background: #fafafa;
    overflow: hidden;
    border-radius: 10px;
}

.img-box img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* SALE BADGE */
.sale-badge {
    position: absolute;
    top: 6px;
    left: 6px;
    background: #ff424e;
    color: #fff;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 4px;
}

/* PRODUCT NAME */
.product-name {
    font-size: 13px;
    line-height: 1.3;
    /* height: 34px; */
    overflow: hidden;
    text-align: center;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

/* PRICE */
.price-box {
    margin-top: 6px;
    text-align: center;
}

.price {
    color: #ff424e;
    font-weight: 700;
    font-size: 15px;
}

.old-price {
    margin-left: 6px;
    font-size: 12px;
    color: #999;
    text-decoration: line-through;
}

.contact-price {
    font-size: 13px;
    color: #999;
    margin-top: 6px;
     text-align: center;
}

/* SOLD */
.sold {
    font-size: 12px;
    color: #777;
    margin-top: 4px;
}
</style>
